import { useState, useEffect } from 'react';
import { isNativeApp } from "../NativeAppBrdige";
import crypto from "crypto-js";
import { toastError } from "../components/base/Toast";
import { Page, CreateButton } from '../models/Page';
import { BreadCrumb } from '../models/Page';
import User from '../modules/accounts/models/User';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import Environment from '../env/env';
import Call from '../modules/voice/calls/models/Call';
import LiveCall from '../modules/voice/calls/models/LiveCall';
import SystemExtension from '../models/SystemExtension';
import SocketContext from './SocketContext';
import { API_ROUTES, NOTIF_PERMISSION_NEVER_KEY } from './Constants';
import Hub from '../api/Hub';
import Wallet from '../models/Wallet';
import Job from '../modules/crm/jobs/models/Job';
import { withFilterTimes } from '../modules/crm/jobs/utils/jobFilters';
import { CallTypes, ChartTimingTypes, DateFormats, JobsChartSegments, TimeFormats, UserTypes } from './Enums';
import Country from '../modules/base/models/Country';
import ChatContactItem from '../modules/chat/models/ChatContactItem';
import { BootstrapColors, FontAwesomeIcons } from './Types';
import AccountPreferences from '../models/AccountPreferences';
import PriceListModel from '../models/PriceListModel';
import TwilioLine from '../modules/voice/lines/models/TwilioLine';
import moment from 'moment';
import JobStatus, { JobStatusCompact } from '../modules/crm/base/models/JobStatus';
import JobReportListModel from '../modules/reports/jobs/models/JobReportListModel';
import { convertTo12HourFormat, getRandomNumber } from './Helper';
import Announcement from '../modules/system/announcements/models/Announcement';
import { resolveTheme } from './Metronic';
import { JobsReportRequest } from '../modules/reports/jobs/models/JobsReportRequest';
import { ChatQuickReplyItem } from '../modules/chat/models/ChatQuickReplyItem ';
import JobInvoice from '../modules/crm/jobs/models/JobInvoice';
import Database from './Database';
import { JobTypeCompact } from '../modules/crm/base/models/JobType';
import { JobMetroCompact } from '../modules/crm/base/models/JobMetro';
import { TagCompact } from '../modules/crm/base/models/TagItem';
import { FlagCompact } from '../modules/crm/base/models/FlagItem';
import { JobColorCompact } from '../modules/crm/base/models/JobColorItem';
import { JobSourceCompact } from '../modules/crm/base/models/JobSource';
import Technician from '../modules/technicians/models/technician';
import { ExtensionCompact } from '../modules/voice/pbx/models/Extension';
import { PhoneLineCompact } from '../modules/voice/lines/models/PhoneLine';
import { QueueCompact } from '../modules/voice/pbx/models/Queue';
import { SipPhoneManager } from './SipPhoneManager';
import CallCompact from '../modules/voice/calls/models/CallCompact';
import { PhoneTabCoordinator } from '../components/phone/PhoneTabCoordinator';


const env = new Environment();
let reconnectSocketRun = true;
let authUser: User;

type FloatAudioStatus = {
    loading?: boolean,
    playing?: boolean
}

type toolbarActionButton = {
    title?: string
    icon?: FontAwesomeIcons
    color?: BootstrapColors
    working?: boolean
    onClick?: () => void
}

interface IComponentState {
    id: string
    close: () => void
}

export interface IState {
    darkMode?: boolean
    countries?: Country[]
    countriesAll?: Country[]
    prices?: PriceListModel
    // The account may send technicians the proxy number instead of the customer's own. Always
    // true for a customer still on the old subscription.
    hasMaskedJobCalls?: boolean
    // Recordings are offered to this account. Nothing has stopped calls being recorded yet --
    // this only decides whether they are offered for listening. Always true for a customer on
    // the old subscription.
    hasCallRecording?: boolean
    // On one of the new plans and on the free one, so there is an upgrade to offer. Never true
    // for a legacy subscription -- those keep the old "Subscribe Now" button.
    canUpgradePlan?: boolean
    // The persistent line every screen carries while a downgrade or a pause is on its way, or
    // the account is paused. Undefined when there is nothing to say.
    planNotice?: PlanNotice
    // Goes up every time the hub says something on this account's subscription changed. The
    // subscription page reads itself again whenever it moves -- one signal for all of it.
    subscriptionVersion?: number
    page?: Page
    pageTitleTap?: (() => void)
    mobileToolbar?: any
    toolbarComponent?: any
    toolbarActions?: any
    modulePageDrawer?: { title: string, link: string }
    bottomComponents?: any
    toolbarButton?: toolbarActionButton
    noToolbar?: boolean
    fitToolbar?: boolean
    createButton?: CreateButton
    user?: User
    ownerUser?: User
    wallet?: Wallet
    roles?: Array<string>
    rolesDenied?: Array<string>
    token?: string
    socket?: HubConnection
    socketState?: HubConnectionState
    selectedCallToPlay?: Call
    selectedCallToListen?: Call | LiveCall
    selectedCallsToShare?: string[]
    hangupChannel?: string
    ChanSpyLine?: any
    floatAudioStatus?: FloatAudioStatus
    deviceId?: string
    systemExt?: SystemExtension
    twilioBuyLine?: TwilioLine
    unreadNotificationsCount?: number
    unseenNotificationsCount?: number
    hub?: Hub<any>
    signupStep?: number
    windowsWidth?: number
    windowsHeight?: number
    createUser?: boolean
    createUserType?: UserTypes
    createJob?: boolean

    duplicateJobId?: string
    messageToJobId?: string
    liveCallJobRefId?: string
    createJobPrefillPhone?: string
    createJobPrefillJobSourceId?: string

    deleteJob?: Job
    reloadAfterDelete?: boolean
    editJobPayment?: Job
    reloadOpenedJob?: boolean
    editJob?: boolean
    editJobId?: string
    selectedJob?: Job
    showTimezoneModal?: boolean
    showLineWizard?: boolean
    chatJob?: Job
    callsDrawerJob?: Job
    archiveJob?: Job
    updateUsers?: boolean
    loginModal?: boolean
    showDefaultTechRateModal?: boolean
    showDefaultSourceRateModal?: boolean

    liveCalls?: LiveCall[]

    chatlist?: ChatContactItem[]
    techChat?: ChatContactItem
    chatsFetched?: boolean
    chatsLoading?: boolean
    selectedChat?: ChatContactItem
    gotoMessageId?: string
    chatUnread?: number


    quickReplies?: ChatQuickReplyItem[]

    announcements?: Announcement[]
    openAnnouncementsDrawer?: boolean


    deviceToken?: string

    accountPreferences?: AccountPreferences
    refreshLinesList?: boolean

    jobStatuses?: JobStatusCompact[]

    jobTypes?: JobTypeCompact[]
    jobSources?: JobSourceCompact[]
    jobMetros?: JobMetroCompact[]
    tags?: TagCompact[]
    flags?: FlagCompact[]
    techs?: Technician[]
    extensions?: ExtensionCompact[]
    queues?: QueueCompact[]
    phoneLines?: PhoneLineCompact[]
    claimedExts?: ExtensionCompact[]
    latestCalls?: CallCompact[]
    missedCallsSeenAt?: number

    initilized?: boolean

    jobsFetched?: boolean
    jobsLoading?: boolean
    jobs?: Job[]
    updateJobList?: (j: Job) => void

    jobColorsFetched?: boolean
    jobColorsLoading?: boolean
    jobColors?: JobColorCompact[]

    contactJobsPhone?: string
    newChatModal?: { phone?: string }
    reportListModal?: JobReportListModel
    quickJobView?: string
    quickJobTab?: string
    /** A technician opened from a map pin. The job quick view stacks on top of it. */
    techQuickView?: string
    // With techQuickView: offered in the drawer as "Select this technician" -- the Metro &
    // Technician drawer opens a technician from its map and takes them from here.
    techQuickViewSelect?: (tech: Technician) => void
    editJobClient?: Job
    editJobAppt?: Job
    editJobAddress?: Job
    editJobTech?: Job
    editJobDetails?: Job
    sendJob?: Job
    copyJob?: Job
    invalidCloseJob?: Job
    invalidCloseErrs?: string
    closeJob?: Job
    closeJobOnClose?: any
    reopenJob?: Job
    reopenToStatus?: JobStatus
    notCalledActions?: Job
    rejectJobByTech?: Job

    invoicesJob?: Job
    invoiceJobView?: JobInvoice
    invoiceJobViewOnClose?: () => void

    attachmentsJob?: Job

    techIdCalendar?: string
    techNameCalendar?: string

    messageToJob?: string
    deleteChat?: ChatContactItem
    chatSettingsModal?: ChatContactItem
    chatAccessDrawer?: ChatContactItem
    chatRenameModal?: ChatContactItem
    chatQuickRepliesModal?: boolean

    updateEnvironemnt?: boolean
    mobileMenuDrawer?: boolean

    jobsReportBody?: JobsReportRequest
    techReportTitle?: string

    showPhone?: boolean

    nativeKeyboardOpened?: boolean

    componentStates?: IComponentState[]
}


export const useComponentStates = () => state.componentStates
export const addComponentState = (item: IComponentState) => {
    setState({
        componentStates: [
            ...(state.componentStates ?? []).filter(f => f.id !== item.id),
            item
        ]
    });
}
export const removeComponentState = (id: string) => {
    setState({
        componentStates: (state.componentStates ?? []).filter(f => f.id !== id)
    });
}

export const loadCashedData = () => {
    const cpk = "IKfytN5XD65kU5qbRHoRarWNWDyaw1lm";
    var c = localStorage.getItem("rinvox-cashed-data");
    if (c) {
        var bytes = crypto.AES.decrypt(c, cpk);
        var data = JSON.parse(bytes.toString(crypto.enc.Utf8));
        return data;
    }
    return undefined;
}

export const setDarkMode = (e: boolean) => setState({
    darkMode: e
})
export const isDarkMode = () => state.darkMode

export const openJobQuickView = (id?: string, tab?: string, overModal?: boolean) => {
    if (isAccountLimited()) {
        window.openModal("modal-user-is-limited");
        return;
    }
    setState({
        quickJobView: id,
        quickJobTab: tab
    })
}

export const openNewChatModal = (phone?: string) => setState({ newChatModal: { phone } })
export const closeNewChatModal = () => setState({ newChatModal: undefined })
export const openNewChatForPhone = (phone: string) => openNewChatModal(phone)

export const closeJobQuickView = () => setState({ quickJobView: undefined })

export const openTechQuickView = (id?: string, onSelect?: (tech: Technician) => void) => setState({ techQuickView: id, techQuickViewSelect: onSelect })
export const closeTechQuickView = () => setState({ techQuickView: undefined, techQuickViewSelect: undefined })

export const openSendJob = (job: Job) => setState({ sendJob: job })
export const closeSendJob = () => setState({ sendJob: undefined })

export const openCopyJob = (job: Job) => canManageJobs() ? setState({ copyJob: job }) : notAllowed("create jobs")
export const closeCopyJob = () => setState({ copyJob: undefined })

export const openEditJobClient = (job: Job) => canManageJobs() ? setState({ editJobClient: job }) : notAllowed("edit jobs")
export const closeEditJobClient = () => setState({ editJobClient: undefined })

export const openEditJobAppt = (job: Job) => canManageJobs() ? setState({ editJobAppt: job }) : notAllowed("edit jobs")
export const closeEditJobAppt = () => setState({ editJobAppt: undefined })

export const openEditJobAddress = (job: Job) => canManageJobs() ? setState({ editJobAddress: job }) : notAllowed("edit jobs")
export const closeEditJobAddress = () => setState({ editJobAddress: undefined })

export const openEditJobTech = (job: Job) => canManageJobs() ? setState({ editJobTech: job }) : notAllowed("edit jobs")
export const closeEditJobTech = () => setState({ editJobTech: undefined })

export const openEditJobDetails = (job: Job) => canManageJobs() ? setState({ editJobDetails: job }) : notAllowed("edit jobs")
export const closeEditJobDetails = () => setState({ editJobDetails: undefined })

export const openArchiveJob = (job: Job) => setState({ archiveJob: job })
export const closeArchiveJob = () => setState({ archiveJob: undefined })

export const rejectJobByTech = (job: Job) => setState({ rejectJobByTech: job })

export const opennotCalledActions = (job: Job) => setState({ notCalledActions: job })
export const closenotCalledActions = () => setState({ notCalledActions: undefined })

export const openBrowserPhone = () => setState({ showPhone: true })
export const closeBrowserPhone = () => setState({ showPhone: false })

export const openInvalidCloseJob = (job: Job, err?: string) => setState({
    invalidCloseJob: job,
    invalidCloseErrs: err
})
export const closeInvalidCloseJob = () => setState({
    invalidCloseJob: undefined,
    invalidCloseErrs: undefined
})

export const openCloseJob = (job: Job, onClosed?: () => void) => {
    if (!state.user?.isTech && !canCloseJob()) return notAllowed("close jobs");
    setState({
        closeJob: job,
        closeJobOnClose: onClosed
    })
}
export const closeCloseJob = () => setState({
    closeJob: undefined,
    closeJobOnClose: undefined
})

export const openInvoicesJob = (job: Job) => setState({
    invoicesJob: job
})
export const closeInvoicesJob = () => setState({
    invoicesJob: undefined
})

export const openInvoicesJobView = (inv: JobInvoice, onClick: () => void) => setState({
    invoiceJobView: inv,
    invoiceJobViewOnClose: onClick
})

export const closeInvoicesJobView = () => setState({
    invoiceJobView: undefined
})

export const openAttachmentsJob = (job: Job) => setState({
    attachmentsJob: job
})
export const closeAttachmentsJob = () => setState({
    attachmentsJob: undefined
})

export const openReopenJob = (job: Job, st: JobStatus) => !canManageJobs() ? notAllowed("edit jobs") : setState({
    reopenJob: job,
    reopenToStatus: st
})
export const closeReopenJob = () => setState({
    reopenJob: undefined,
    reopenToStatus: undefined
})

export const openTechCalendarModal = (techId?: string, techName?: string) => setState({
    techIdCalendar: techId,
    techNameCalendar: techName
})
export const closeTechCalendarModal = () => setState({
    techIdCalendar: undefined,
    techNameCalendar: undefined
})

export const openMessageToJob = (msg: string, msgId: string) => !canManageJobs() ? notAllowed("create jobs") : setState({
    messageToJob: msg,
    createJob: true,
    messageToJobId: msgId
})
export const closeMessageToJob = () => setState({
    messageToJob: undefined
})
export const clearMessageToJob = () => setState({
    messageToJob: undefined,
    messageToJobId: undefined
})



export const openReportJobsList = (list: JobReportListModel) => setState({
    reportListModal: list
})
export const closeReportJobsList = () => setState({
    reportListModal: undefined
})


export const openContactActiveJobs = (phone: string) => setState({
    contactJobsPhone: phone
})
export const closeContactActiveJobs = () => setState({
    contactJobsPhone: undefined
})


export const useLiveCalls = () => state.liveCalls

export const setLiveCalls = (calls: LiveCall[]) => setState({ liveCalls: calls })

export const addOrUpdateLiveCall = (newCall: LiveCall) => {
    setState({
        liveCalls: state.liveCalls?.some(call => call.id === newCall.id)
            ? state.liveCalls?.map(call =>
                call.id === newCall.id ? newCall : call
            )
            : [...(state.liveCalls ?? []), newCall]
    });
}

export const endLiveCall = (call: LiveCall) => {
    setState({
        liveCalls: state.liveCalls?.filter(c => c.id !== call.id)
    });
}


export const useClaimedExts = () => state.claimedExts
export const addOrUpdateClaimedExt = (newExt: ExtensionCompact) => {
    setState({
        claimedExts: state.claimedExts?.some(e => e.id === newExt.id)
            ? state.claimedExts?.map(e =>
                e.id === newExt.id ? newExt : e
            )
            : [...(state.claimedExts ?? []), newExt]
    });
}
export const removeClaimedExt = (extId: string) => {
    setState({
        claimedExts: state.claimedExts?.filter(e => e.id != extId)
    });
}

export const useLatestCalls = () => state.latestCalls
export const setLatestCalls = (calls: CallCompact[]) => setState({ latestCalls: calls });
// Append an older page of calls to the bottom of the list (infinite scroll in the dialer).
// De-dupes by id so a re-fetched cursor-boundary row (or a real-time push that already landed)
// is never shown twice.
export const appendLatestCalls = (calls: CallCompact[]) => {
    const existing = state.latestCalls ?? [];
    const existingIds = new Set(existing.map(c => c.id));
    const fresh = calls.filter(c => !existingIds.has(c.id));
    if (fresh.length === 0) return;
    setState({ latestCalls: [...existing, ...fresh] });
}
export const addOrUpdateLatestCall = (newCall: CallCompact) => {
    const existing = state.latestCalls ?? [];
    // The same call is pushed twice: once by AsteriskLiveUpdates the moment it ends (real-time, but
    // duration/recording not in the CDR yet) and again by AsteriskSyncCalls once the CDR is complete
    // (correct duration + recording file). So we must UPDATE the existing entry in place, not bail out —
    // otherwise the enriched data never reaches the UI without a refresh.
    if (existing.some(c => c.id === newCall.id)) {
        setState({
            latestCalls: existing.map(c => c.id === newCall.id ? { ...c, ...newCall } : c)
        });
        return;
    }
    setState({
        latestCalls: [newCall, ...existing]
    });
}

// --- Missed-calls "seen" tracking ---
// Per-user, per-browser timestamp of the last time the user opened the Calls tab in the dialer.
// Missed calls whose callDate > this timestamp are considered "unseen" and drive the red badge
// on the header phone icon and the dialer's Calls tab.
const missedSeenKey = (userId: string) => `rnx:missedCallsSeenAt:${userId}`;

const readMissedSeenAt = (userId?: string): number => {
    if (!userId) return 0;
    try {
        const raw = localStorage.getItem(missedSeenKey(userId));
        return raw ? Number(raw) || 0 : 0;
    } catch {
        return 0;
    }
};

export const useMissedCallsSeenAt = () => state.missedCallsSeenAt ?? 0;

export const hydrateMissedCallsSeenAt = () => {
    const userId = state.user?.id;
    if (!userId) return;
    setState({ missedCallsSeenAt: readMissedSeenAt(userId) });
};

export const markMissedCallsSeen = () => {
    const userId = state.user?.id;
    if (!userId) return;
    const now = Date.now();
    try { localStorage.setItem(missedSeenKey(userId), String(now)); } catch { }
    setState({ missedCallsSeenAt: now });
};

const isMissedCall = (c: CallCompact): boolean =>
    c.callType === CallTypes.Incoming &&
    (c.disPosition ?? "").toUpperCase() !== "ANSWERED";

/// Count of missed incoming calls newer than the last time the user viewed the Calls tab.
/// IMPORTANT: subscribes to global state via useGlobal() so the badge re-renders the moment a new
/// AddLatestCall SignalR event lands — without this, the count is stale until something else
/// triggers a re-render of the host component (forcing a page refresh to "see" the missed call).
export const useUnseenMissedCallsCount = (): number => {
    const [s] = useGlobal();
    const calls = s.latestCalls;
    const seenAt = s.missedCallsSeenAt ?? 0;
    if (!calls || calls.length === 0) return 0;
    let count = 0;
    for (const c of calls) {
        if (!isMissedCall(c)) continue;
        const t = c.callDate ? new Date(c.callDate).getTime() : 0;
        if (t > seenAt) count++;
    }
    return count;
};

export const openDeleteChat = (chat: ChatContactItem) => setState({ deleteChat: chat })
export const closeDeleteChat = () => setState({ deleteChat: undefined })

export const openSettingsChat = (chat: ChatContactItem) => setState({ chatSettingsModal: chat })
export const closeSettingsChat = () => setState({ chatSettingsModal: undefined })

export const openChatAccess = (chat: ChatContactItem) => setState({ chatAccessDrawer: chat })
export const closeChatAccess = () => setState({ chatAccessDrawer: undefined })

export const openChatRename = (chat: ChatContactItem) => setState({ chatRenameModal: chat })
export const closeChatRename = () => setState({ chatRenameModal: undefined })

export const openChatQuickReplies = () => setState({ chatQuickRepliesModal: true })
export const closeChatQuickReplies = () => setState({ chatQuickRepliesModal: false })


// Active jobs and the chat contact list used to arrive together in a single
// /base/init/board call fired at app bootstrap, so every page — settings included —
// waited on a payload only the jobs and chat views actually need. They are now two
// separate endpoints, each fetched the first time a view that needs it mounts and then
// kept in state for the rest of the session, so navigating back costs nothing.

export const loadJobs = (force?: boolean) => {
    if (state.jobsLoading) return;
    if (!force && state.jobsFetched) return;
    setState({ jobsLoading: true });
    getHub().Get("/base/init/jobs",
        res => {
            if (res.success && res.data) setState({ jobs: (res.data as Job[]).map(withFilterTimes), jobsFetched: true, jobsLoading: false });
            else setState({ jobsLoading: false });
        },
        () => setState({ jobsLoading: false }));
}

export const loadChats = (force?: boolean) => {
    if (state.chatsLoading) return;
    if (!force && state.chatsFetched) return;
    setState({ chatsLoading: true });
    getHub().Get("/base/init/chats",
        res => {
            if (res.success && res.data) setState({
                chatlist: res.data.chats,
                techChat: res.data.techChat,
                chatsFetched: true,
                chatsLoading: false
            });
            else setState({ chatsLoading: false });
        },
        () => setState({ chatsLoading: false }));
}

/**
 * Socket reconnect handler: re-pull only the slices a view has already loaded, so a
 * reconnect never drags in data nothing on screen is using.
 */
export const refetchLoadedData = () => {
    if (state.jobsFetched) loadJobs(true);
    if (state.chatsFetched) loadChats(true);
}

/** Loads active jobs once the session is ready, unless they're already in state. */
export const useEnsureJobs = () => {
    const [global] = useGlobal();
    useEffect(() => {
        if (global.initilized && global.user) loadJobs();
    }, [global.initilized, global.user])
}

/**
 * The account's job colour palette (CRM > Base Data > Job Colors). Small and rarely changed, so it
 * is fetched once per session and then refreshed by whoever edits it.
 */
export const useJobColors = () => state.jobColors ?? []
/** Same as useJobColors, for plain functions (option templates) where a "use" name trips the hooks lint. */
export const getJobColors = () => state.jobColors ?? []

export const loadJobColors = (force?: boolean) => {
    if (state.jobColorsLoading) return;
    if (!force && state.jobColorsFetched) return;
    setState({ jobColorsLoading: true });
    getHub().Get("/base/JobColors/all",
        res => {
            if (res.success && res.data) setState({ jobColors: res.data, jobColorsFetched: true, jobColorsLoading: false });
            else setState({ jobColorsLoading: false });
        },
        () => setState({ jobColorsLoading: false }));
}

/** Loads the job colour palette once the session is ready, unless it's already in state. */
export const useEnsureJobColors = () => {
    const [global] = useGlobal();
    useEffect(() => {
        if (global.initilized && global.user) loadJobColors();
    }, [global.initilized, global.user])
}

/** Loads the chat contact list once the session is ready, unless it's already in state. */
export const useEnsureChats = () => {
    const [global] = useGlobal();
    useEffect(() => {
        if (global.initilized && global.user) loadChats();
    }, [global.initilized, global.user])
}

export const useJobs = () => state.jobs
export const useJob = (id?: string) => {
    if (!id) return undefined;
    if (id.length == 7) return state.jobs?.find(f => f.jobId?.toLowerCase() == id.toLowerCase());
    return state.jobs?.find(f => f.id == id);
}
export const setJobs = (data: Job[]) => setState({ jobs: data })

export const addOrUpdateJob = (newJob: Job) => {
    if (newJob.ownerUserId !== state.ownerUser?.id) return;
    withFilterTimes(newJob);
    // Who made the last status change is read from the status history when the board loads,
    // for jobs saved before it was recorded. A pushed copy of such a job lacks it: keep the one
    // the board has while the status hasn't changed since.
    const old = state.jobs?.find(job => job.id === newJob.id);
    if (!newJob.lastStatusUser && old?.lastStatusUser && old.jobStatusId == newJob.jobStatusId
        && String(old.lastStatusUpdatedAt) == String(newJob.lastStatusUpdatedAt))
        newJob.lastStatusUser = old.lastStatusUser;
    if (hasAccessToSource(newJob.jobSourceId)) {
        setState({
            jobs: state.jobs?.some(job => job.id === newJob.id)
                ? state.jobs?.map(job =>
                    job.id === newJob.id ? newJob : job
                )
                : [...(state.jobs ?? []), newJob]
        });

        if (state.updateJobList) state.updateJobList(newJob);
    }
}

/**
 * Merges a partial change into a job that's already in the bank, so the UI repaints in the same
 * frame instead of waiting for the socket round trip. Unlike addOrUpdateJob this never inserts a
 * job and never checks ownerUserId — board jobs come from JobBoardModel, which doesn't carry it.
 * The live-hub push that follows still overwrites the job with the server's authoritative copy.
 */
export const patchJob = (id?: string, changes?: Partial<Job>) => {
    if (!id || !changes) return;
    if (!state.jobs?.some(job => job.id === id)) return;
    setState({
        jobs: state.jobs.map(job => job.id === id ? withFilterTimes({ ...job, ...changes }) : job)
    });
}

export const removeJob = (rmJob: Job) => {
    setState({
        jobs: state.jobs?.filter(job => job.id != rmJob.id)
    });
}

export const archiveJobs = (ids: string[]) => {
    setState({
        jobs: state.jobs?.filter(job => job.id && !ids.includes(job.id))
    });
}

export const useJobsReportBody = () => state.jobsReportBody
export const loadJobsReportBody = (user: User) => {

    var body: JobsReportRequest = {
        chartTiming: ChartTimingTypes.Day,
        segment: JobsChartSegments.ClosedJobs,
        dateId: "1",
        segmentIds: [],
        metric1: "",
        metric2: "",
        metric3: "",
        startDate: window.now(-30).format("DD/MM/YYYY"),
        toDate: window.now().format("DD/MM/YYYY")
    }

    if (user.isTech && user.id) {
        body.dateId = "3";
        body.segment = JobsChartSegments.Payments;
        body.segmentIds.push(user.id);
    }
    else {
        var jobs_report_body = localStorage.getItem("jobs_report_body");
        if (!window.isNullOrEmpty(jobs_report_body)) {
            var bd: JobsReportRequest = JSON.parse(jobs_report_body ?? "");
            if (bd) body = bd;
        }
    }

    setState({
        jobsReportBody: body,
        techReportTitle: "Current Week"
    })
}

export const setJobsReportBody = (body: JobsReportRequest) => {
    setState({
        jobsReportBody: body
    })
    localStorage.setItem("jobs_report_body", JSON.stringify(body));
}


export const setPage = async (title: string, ...breadcrumbs: string[]) => {

    var breadCrumbs = new Array<BreadCrumb>();
    breadcrumbs.forEach(item => breadCrumbs.push({
        title: item[0].toUpperCase() + item.substring(1),
        link: "#"
    }));
    setState({
        page: {
            title: title[0].toUpperCase() + title.substring(1),
            breadCrumb: breadCrumbs
        }
    })

    const unread = (state.chatlist ?? []).reduce((s, c) => s + (c.unreadCount ?? 0), 0);
    const badge = (title.toLowerCase() === "chat" && unread > 0) ? `(${unread}) ` : "";
    document.title = badge + title + " - " + env.siteTitle;
}

export const clearPageName = async () => setState({
    page: undefined
})

export const setPageWithToolbarComponent = async (title: string, comp: any) => {
    setState({
        page: {
            title: title[0].toUpperCase() + title.substring(1),
            breadCrumb: undefined
        },
        toolbarComponent: comp
    })

    const unread = (state.chatlist ?? []).reduce((s, c) => s + (c.unreadCount ?? 0), 0);
    const badge = (title.toLowerCase() === "chat" && unread > 0) ? `(${unread}) ` : "";
    document.title = badge + title + " - DSPVoice";
}

export const setPageCount = async (count?: number) => {
    setState({
        page: {
            ...state.page,
            count: count
        }
    });
}

export const setBottomComponents = (components?: any) => setState({ bottomComponents: components })

export const setSignupStep = async (step: number) => setState({ signupStep: step })

export const useCountries = () => state.countries

// The countries this account takes jobs in (System > Other Settings > Active Countries),
// out of the system-wide active list. The phone, address and job forms offer only these.
// The HUB already defaults an unset preference to the United States; the same fallback is
// kept here for a stale cached preference, and when none of the saved ids match a country.
// Memoised on the two inputs so callers can put the result in effect dependencies without
// re-running on every render.
let activeCountriesMemo: { all?: Country[], ids?: string[], result: Country[] } = { result: [] }
export const getActiveCountries = (): Country[] | undefined => {
    const all = state.countries
    if (!all) return undefined
    const ids = state.accountPreferences?.activeCountries
    if (activeCountriesMemo.all === all && activeCountriesMemo.ids === ids) return activeCountriesMemo.result

    var result = ids && ids.length > 0 ? all.filter(c => ids.includes(c.id!)) : []
    if (result.length == 0) result = all.filter(c => c.alpha2Code?.toLowerCase() == "us")
    if (result.length == 0) result = all

    activeCountriesMemo = { all, ids, result }
    return result
}
export const useActiveCountries = () => getActiveCountries()

// The country a new phone or address field starts on: the United States when it is active,
// otherwise the first active country.
export const getDefaultActiveCountry = (): Country => {
    const active = getActiveCountries()
    if (!active || active.length == 0) return getUSA()
    return active.find(c => c.alpha2Code?.toLowerCase() == "us") ?? active[0]
}

export const isActiveCountry = (id?: string): boolean =>
    !!id && !!getActiveCountries()?.some(c => c.id == id)

export const useAllCountries = () => state.countriesAll?.sort((a, b) => {
    if (a.alpha3Code?.toLowerCase() === "usa") return -1;
    if (b.alpha3Code?.toLowerCase() === "usa") return 1;
    return a.name!.localeCompare(b.name!);
});

export const useScreen = () => {
    return {
        width: state.windowsWidth ?? 0,
        height: state.windowsHeight ?? 0,
        heightDoc: (state.windowsHeight ?? 0) - 65 - (state.noToolbar ? 0 : 55),
        isMobile: (state.windowsWidth ?? 0) < 600
    }
}

// Creation order -- the database default, which is what the create-job form shows. The form's
// default pick is the first entry, and that has to stay the seeded "Submitted" status however
// the account has since arranged its board.
export const jobStatusesInCreationOrder = <T extends { id?: string }>(items?: T[]): T[] =>
    [...(items ?? [])].sort((a, b) => (a.id ?? "").localeCompare(b.id ?? ""))

export const useStatuses = () => state.jobStatuses ?? []
export const useStatusesForJob = () => state.jobStatuses?.filter(f => !f.isPendingClosed && (canCloseJob() || !f.isClosed)) ?? []
// Two different orders, both needed, so neither is left to chance: the IndexedDB cache is read
// with getAll() which returns records by key, and a live socket push arrives in the server's
// order, so the same list reaches the app ordered differently depending on the path it took.
// Every reader therefore asks for the order it wants rather than trusting what is in state.

// The account's manual order (set by dragging on the Job Statuses page). Statuses with no sort
// fall back to creation order, which ObjectId ids already give us.
export const sortJobStatuses = <T extends { id?: string, sort?: number }>(items?: T[]): T[] =>
    [...(items ?? [])].sort((a, b) => {
        const as = a.sort, bs = b.sort
        if (as != null && bs != null) return as - bs
        if (as != null) return -1
        if (bs != null) return 1
        return (a.id ?? "").localeCompare(b.id ?? "")
    })

export const useStatusesForCreateJob = () => jobStatusesInCreationOrder(state.jobStatuses?.filter(f => !f.isPendingClosed && !f.isClosed && !f.isCanceled))
export const useStatusesForChatTechJobs = () => state.jobStatuses?.filter(f => f.isInProgress || f.isAppointment) ?? []

export const updateStatuses = (data: any) => setState({ jobStatuses: data })

export const useJobTypes = () => state.jobTypes ?? []
export const useJobSources = () => state.jobSources ?? []
export const useJobMetros = () => state.jobMetros ?? []
export const useTags = () => state.tags ?? []
export const useFlags = () => state.flags ?? []

// A technician who can still be given work: neither suspended nor deleted. The full list
// (useTechsAll) still carries both, so old jobs keep the name of whoever did them.
export const isActiveTech = (t?: Technician) => !!t && !t.suspended && !t.trashed
export const useTechs = () => state.techs?.filter(isActiveTech) ?? []
export const useTechsAll = () => state.techs ?? []

export const useExtensions = () => state.extensions ?? []
export const usePhoneLines = () => state.phoneLines ?? []
export const useQueues = () => state.queues ?? []

export const setChatList = (data: any) => setState({ chatlist: data })

export const goToMessage = (id: string) => {
    setState({ gotoMessageId: id })
    setTimeout(() => {
        setState({ gotoMessageId: undefined })
    }, 1000);
}

export const setQuickReplies = (data: any) => setState({ quickReplies: data })
export const useQuickReplies = () => state.quickReplies ?? []

export const useChatList = () => state.chatlist
export const useUnreadChatsCount = () => {
    var res = 0;
    state.chatlist?.forEach(c => {
        res += (c.unreadCount ?? 0)
    });
    return res;
}

export const selectChat = (ch: ChatContactItem) => setState({ selectedChat: ch })
export const closeChat = () => setState({ selectedChat: undefined })
export const selectChatById = (id: string) => {
    var ch = state.chatlist?.find(f => f.chatId == id);
    if (ch) setState({ selectedChat: ch })
}

// Clears the unread badge for an internal/system chat locally. Called once the chat is already
// open (selection is stable), so it doesn't feed the selection effect into a loop. The server
// marks the messages read on load for persistence.
export const clearSystemChatUnread = (chatId?: string) => {
    if (!chatId) return;
    if (!state.chatlist?.some(c => c.chatId === chatId && (c.unreadCount ?? 0) > 0)) return;
    setState({
        chatlist: state.chatlist?.map(c => c.chatId === chatId ? { ...c, unreadCount: 0 } : c),
        selectedChat: state.selectedChat?.chatId === chatId
            ? { ...state.selectedChat, unreadCount: 0 }
            : state.selectedChat
    })
}
export const useSelectedChat = () => state.selectedChat

// Drops a chat from the live list (it was archived). The chat itself stays open if it is the
// selected one — only the list entry goes away.
export const removeChat = (chatId?: string) => {
    if (!chatId) return;
    if (!state.chatlist?.some(c => c.chatId === chatId)) return;
    setState({ chatlist: state.chatlist?.filter(c => c.chatId !== chatId) })
}

// Loads this person's unread count for a system chat (Office, Rinvox), which counts per member.
const refreshSystemChatUnread = (chatId: string) => {
    getHub().Get(API_ROUTES.Chat + "unread/" + chatId, res => {
        if (!res.success || typeof res.data !== "number") return;
        if (state.selectedChat?.chatId === chatId) return;
        if (!state.chatlist?.some(c => c.chatId === chatId)) return;
        setState({
            chatlist: state.chatlist?.map(c => c.chatId === chatId ? { ...c, unreadCount: res.data } : c)
        })
    })
}

export const addOrUpdateChat = (ch: ChatContactItem) => {
    if (state.user?.userType == UserTypes.Technician) {
        setState({ techChat: ch })
        return;
    }

    if (!ch.accessAll && !ch.accessReadUserIds?.includes(state.user?.id ?? "---")) {
        return;
    }

    // An archived chat never belongs in the live list — whoever sends it here (a background
    // update on an already archived chat) means "remove", not "add".
    if (ch.archived) {
        removeChat(ch.chatId);
        return;
    }

    // Internal/system chats track unread per member on the client, because the server's global
    // unread count can't represent a per-user value. A new message is detected via lastUpdateDate,
    // which only changes when a message is sent (not on pin/access/other chat updates).
    if (ch.isSystem) {
        const existing = state.chatlist?.find(c => c.chatId === ch.chatId);
        const myId = state.user?.id;
        const isOpen = state.selectedChat?.chatId === ch.chatId;
        const isNewMessage = !!existing && !!ch.lastUpdateDate && !!existing.lastUpdateDate
            && new Date(ch.lastUpdateDate).getTime() > new Date(existing.lastUpdateDate).getTime();

        let unread = existing?.unreadCount ?? 0;
        if (isOpen) unread = 0;
        else if (isNewMessage && ch.lastSenderUserId && ch.lastSenderUserId !== myId) unread = unread + 1;

        ch.unreadCount = unread;

        // Not in the list yet: it is coming back from the archive (a new message, or unarchived
        // by hand). The pushed chat cannot say what this person has not read, so ask.
        if (!existing && !isOpen && ch.chatId) refreshSystemChatUnread(ch.chatId);
    }

    setState({
        chatlist: state.chatlist?.some(c => c.chatId === ch.chatId)
            ? state.chatlist?.map(c =>
                c.id === ch.id ? ch : c
            )
            : [...(state.chatlist ?? []), ch]
    });

    if (state.selectedChat?.chatId == ch.chatId) {
        setState({ selectedChat: ch });
    }

    if (state.page?.title?.toLowerCase() === "chat") {
        const updatedList = state.chatlist?.some(c => c.chatId === ch.chatId)
            ? state.chatlist?.map(c => c.id === ch.id ? ch : c)
            : [...(state.chatlist ?? []), ch];
        const unread = (updatedList ?? []).reduce((s, c) => s + (c.unreadCount ?? 0), 0);
        const badge = unread > 0 ? `(${unread}) ` : "";
        document.title = badge + "Chat" + " - " + env.siteTitle;
    }
}


export const useAnnouncements = () => state.announcements
export const openAnnouncements = () => setState({ openAnnouncementsDrawer: true })
export const closeAnnouncements = () => setState({ openAnnouncementsDrawer: false })

export const addOrUpdateAnnouncement = (an: Announcement) => {
    setState({
        announcements: state.announcements?.some(c => c.id === an.id)
            ? state.announcements?.map(c =>
                c.id === an.id ? an : c
            )
            : [...(state.announcements ?? []), an]
    });

}

export const dismissAnnouncement = (an: Announcement) => {
    setState({
        announcements: state.announcements?.filter(a => a.id != an.id)
    })
}


export const getCountry = (id?: string) => {
    var res = state.countriesAll?.filter(f => f.id == id);
    if (res && res.length > 0) return res[0];
    return undefined;
}

export const getCountryByCode = (code?: string) => {
    if (code?.length == 2) {
        return state.countriesAll?.filter(f => f.alpha2Code?.toLowerCase() == code.toLowerCase())[0]
    }
    if (code?.length == 3) {
        return state.countriesAll?.filter(f => f.alpha3Code?.toLowerCase() == code.toLowerCase())[0]
    }

    return undefined;
}

export const getUSA = () => {
    var us: Country = {};
    state.countries?.forEach(c => {
        if (c.alpha2Code?.toLowerCase() == "us") us = c;
    });
    return us;
}

export const usePrices = () => state.prices

export const useHasMaskedJobCalls = () => state.hasMaskedJobCalls ?? false

export const useHasCallRecording = () => state.hasCallRecording ?? false

export const useCanUpgradePlan = () => state.canUpgradePlan ?? false

export interface PlanNotice {
    /** "downgrade" or "hold" when scheduled, "onhold" while paused. */
    kind?: string
    text?: string
    date?: string
    /** What the banner's button says, or nothing when there is nothing to do from it. */
    action?: string
    /** The plan the account is on, and the one a scheduled change moves it to (not for a pause). */
    currentPlanName?: string
    planName?: string
}

export const usePlanNotice = () => state.planNotice

export const setPlanNotice = (notice?: PlanNotice) => setState({ planNotice: notice ?? undefined })

export const useSubscriptionVersion = () => state.subscriptionVersion ?? 0

// The hub's "SubscriptionChanged": something on this account's plan, add-ons, numbers, usage or
// sign-ins changed. Everything on the subscription page follows subscriptionVersion; the header's
// plan line is read again here, since it shows on every screen and not only that one.
export const onSubscriptionChanged = () => {
    setState({ subscriptionVersion: (state.subscriptionVersion ?? 0) + 1 })

    if (state.user?.isTech) return
    getHub().Get("/accounts/profile/plan/notice", res => {
        if (res?.success) setPlanNotice(res.data ?? undefined)
    })
}

export const setMobileToolbar = async (comp: any) => setState({ mobileToolbar: comp })
// When set (mobile only), the MobileHeader renders its title as a tappable selector.
export const setPageTitleTap = (cb?: () => void) => setState({ pageTitleTap: cb })
export const setToolbarComponent = async (comp: any) => setState({ toolbarComponent: comp })
export const setToolbarActions = async (comp: any) => setState({ toolbarActions: comp })

// Opens a module sidebar page inside a drawer at App level (base "/"), so its
// <Routes location> can match any absolute path without a parent-base clash.
export const openModulePageDrawer = (title: string, link: string) => setState({ modulePageDrawer: { title, link } })
export const closeModulePageDrawer = () => setState({ modulePageDrawer: undefined })

export const setToolbarButton = async (comp: toolbarActionButton) => setState({ toolbarButton: comp })
export const updateToolbarButtonWorking = async (w: boolean) => setState({
    toolbarButton: {
        ...state.toolbarButton,
        working: w
    }
})
export const updateToolbarButtonAction = async (a: () => void) => setState({
    toolbarButton: {
        ...state.toolbarButton,
        onClick: a
    }
})
export const clearToolbarButton = async () => setState({ toolbarButton: undefined })

export const clearToolbar = async () => setState({ toolbarActions: undefined, toolbarComponent: undefined })

export const openLoginModal = () => {
    // Inside the native app the login lives outside this page. Showing the modal here would put
    // a second front door behind the first one the user already came through, so the session is
    // handed back instead and the app returns to its own sign-in.
    if (isNativeApp()) {
        document.location.replace("rinvox://logout")
        return
    }
    setState({ loginModal: true })
}
export const closeLoginModal = () => setState({ loginModal: false })

export const openUpdateEnvironment = () => setState({ updateEnvironemnt: true })
export const closeUpdateEnvironment = () => setState({ updateEnvironemnt: false })

export const openMobileMenu = () => setState({ mobileMenuDrawer: true })
export const closeMobileMenu = () => setState({ mobileMenuDrawer: false })

export const setChatJob = (job: Job) => setState({ chatJob: job })
export const clearChatJob = () => setState({ chatJob: undefined })
export const getChatJob = () => state.chatJob

export const setCallsJob = (job: Job) => setState({ callsDrawerJob: job })
export const clearCallsJob = () => setState({ callsDrawerJob: undefined })
export const getCallsJob = () => state.callsDrawerJob

export const refreshLinesList = () => {
    setState({ refreshLinesList: true });
    setTimeout(() => {
        setState({ refreshLinesList: false });
    }, 1000);
}

export const setUser = async (user: User) => {
    await setState({
        user: user,
        showTimezoneModal: (user.timeZoneId == null)
    });
}

export const setRoles = async (roles: string[]) => {
    await setState({ roles: roles });
}

export const getUser = () => state.user
export const getOwner = () => state.ownerUser

// True when the account is limited (subscription lapsed). Checks the owner's flag too, because for
// sub-users (Admin/Dispatcher/Technician) their own `limited` is false while the owner's may be true.
export const isAccountLimited = () => !!(state.user?.limited || state.ownerUser?.limited)

// Applies a live limited-state change (from the AccountLimited/AccountUnlimited socket events) by
// updating both the user's and owner's flags so isAccountLimited() and all guards react immediately.
export const setAccountLimited = (limited: boolean) => {
    const patch: any = {};
    if (state.user) patch.user = { ...state.user, limited };
    if (state.ownerUser) patch.ownerUser = { ...state.ownerUser, limited };
    setState(patch);
}

export const setOwner = async (user: User) => {
    await setState({
        ownerUser: user
    });
}

export const isDemo = () => {
    return state.user?.username == "demo";
}
export const isRoot = () => {
    return state.user?.username == "root";
}
export const demoText = (str?: string) => str?.substring(0, 1).toUpperCase()
export const demoPhone = () => {
    return "+1" + getRandomNumber(111, 999) + "XXXXX" + getRandomNumber(11, 99)
}

export const usePreferences = () => state.accountPreferences
export const updatePreferences = (data: AccountPreferences) => setState({ accountPreferences: data })

export const createUser = () => setState({ createUser: true })
export const createUserDismiss = () => setState({ createUser: false })

export const createUserWithType = (type: UserTypes) => setState({ createUserType: type })
export const createUserWithTypeDismiss = () => setState({ createUserType: undefined })

export const createJob = (duplicateId?: string, liveCallId?: string, prefill?: { phone?: string; jobSourceId?: string }) => {
    if (!canManageJobs()) return notAllowed("create jobs");
    if (isAccountLimited()) {
        window.openModal("modal-user-is-limited");
        return;
    }
    setState({
        createJob: true,
        duplicateJobId: duplicateId,
        liveCallJobRefId: liveCallId,
        createJobPrefillPhone: prefill?.phone,
        createJobPrefillJobSourceId: prefill?.jobSourceId
    })
}

export const closeJob = () => {
    setState({
        createJob: false,
        editJob: false,
        editJobId: undefined,
        selectedJob: undefined,
        messageToJob: undefined,
        messageToJobId: undefined,
        createJobPrefillPhone: undefined,
        createJobPrefillJobSourceId: undefined
    })
}
export const editJob = (job: Job) => {
    if (!canManageJobs()) return notAllowed("edit jobs");
    if (isAccountLimited()) {
        window.openModal("modal-user-is-limited");
        return;
    }
    setState({
        editJob: true,
        editJobId: job.id,
        selectedJob: job
    })
}

export const deleteJobOpen = (job?: Job) => {
    setState({
        deleteJob: job
    })
}
export const deleteJobClose = () => {
    setState({
        deleteJob: undefined
    })
}

export const reloadAfterDelete = () => {
    setState({
        reloadAfterDelete: true
    })
    setTimeout(() => {
        setState({
            reloadAfterDelete: false
        })
    }, 500);
}

export const editJobPaymentOpen = (job?: Job) => {
    setState({
        editJobPayment: job
    })
}
export const editJobPaymentClose = () => {
    setState({
        editJobPayment: undefined
    })
}

export const reloadOpenedJob = () => {
    setState({
        reloadOpenedJob: true
    })
    setTimeout(() => {
        setState({
            reloadOpenedJob: false
        })
    }, 500);
}

export const showLineWizard = () => setState({ showLineWizard: true })
export const hideLineWizard = () => setState({ showLineWizard: false })

export const showDefaultTechRateModal = () => setState({ showDefaultTechRateModal: true })
export const hideDefaultTechRateModal = () => setState({ showDefaultTechRateModal: false })

export const updateUsersOn = () => {
    setState({ updateUsers: true });
    setTimeout(() => {
        setState({ updateUsers: false });
    }, 500);
}


export const setWallet = async (wallet: Wallet) => {
    await setState({ wallet: wallet })
}

export const useWallet = () => state.wallet

let socketInterval: NodeJS.Timeout;
export const useSocket = () => {
    return SocketContext.instance;
}
export const newSocket = () => {
    return new SocketContext();
}

// Where to point a call recording player. The Voice/Office build serves the hub on two hosts:
// localHubUrl is the one inside the office, on a private address that resolves nowhere else, and
// apiUrl is the public one. Technicians and the account owner are allowed to listen from outside
// the office, so their player has to be aimed at the public host — pointed at the office host the
// browser never gets a connection at all, no matter what the server would have permitted. Everyone
// else keeps the office host, which is what confines them to the office network in the first place.
// Every other build has no separate localHubUrl, so both branches are the same URL there.
export const callRecordingUrl = (ownerId?: string, callId?: string) => {
    const env = Environment.instance
    const user = state.user
    const allowedOutsideOffice = user?.userType == UserTypes.Technician || (!!user?.id && user.id == state.ownerUser?.id)
    const host = allowedOutsideOffice ? env.hubUrl : env.localHubUrl
    return `${host}/system/calls/recording/${ownerId}/${callId}?userId=${user?.id}`
}

export const useEnvironment = () => Environment.instance
export const useDatabase = () => Database.instance

export const usePhoneTabCoordinator = () => PhoneTabCoordinator.instance
export const usePhone = () => SipPhoneManager.instance



let hubInstance: Hub<any> | undefined;

// Plain accessor for the shared Hub — usable from non-component code (loaders, socket
// handlers). useHub is the same thing under a use* name for components.
export const getHub = () => {
    if (!hubInstance) {
        hubInstance = new Hub();
    }
    return hubInstance;
}

export const useHub = () => getHub()

// Before every outgoing browser call, the HUB is asked whether the account can pay for it
// (minutes left on the plan, or a wallet above fifty cents). A refusal is shown here and
// stops the call before it is placed; a slow or failed check never blocks dialling.
SipPhoneManager.instance.beforeDial = () => new Promise<string | undefined>(resolve => {
    let settled = false
    const finish = (msg?: string) => { if (!settled) { settled = true; resolve(msg) } }
    const timer = window.setTimeout(() => finish(undefined), 5000)
    getHub().Get(API_ROUTES.Lines + "cancall", res => {
        window.clearTimeout(timer)
        if (res.success && res.data && res.data.allowed === false) {
            const msg: string = res.data.message ?? "Your wallet balance is not enough to make a call. Top up your wallet to make calls."
            toastError(msg)
            finish(msg)
        }
        else finish(undefined)
    })
})

export const useSIP = () => {
    return window.GetSIPInstance();
}

export const setUnreadNotificationsCount = async (count: number) => setState({ unreadNotificationsCount: count })
export const setUnseenNotificationsCount = async (count: number) => setState({ unseenNotificationsCount: count })
export const addUnseenNotificationsCount = async () => setState({ unseenNotificationsCount: ((state.unseenNotificationsCount ?? 0) + 1) })

export const setSocketState = async (state: HubConnectionState) => setState({ socketState: state })

export const setCreateButton = async (name: string, route: string, modal?: string) => setState({
    createButton: {
        objectName: name,
        modal: modal,
        route: route
    }
})

export const clearCreateButton = async () => setState({
    createButton: undefined
})

export const setSystemExt = async (ext: SystemExtension) => {
    await setState({ systemExt: ext });
}


export const setUserId = (userId: string) => {
    localStorage.setItem("dspvoice-user-id", userId);
}

export const getUserId = () => {
    return localStorage.getItem("dspvoice-user-id");
}

export const setOwnerUserId = (ownerId: string) => {
    localStorage.setItem("rinvox-owner-user-id", ownerId);
}

export const useOwnerUserId = () => {
    return localStorage.getItem("rinvox-owner-user-id") ?? state.user?.ownerUserId;
}


export const logout = () => {

    // Outside the promise below: whoever signs in next has to be asked about
    // notifications again, even if clearing the local database fails.
    localStorage.removeItem(NOTIF_PERMISSION_NEVER_KEY);

    const db = new Database()
    db.deleteDatabase().then(() => {
        localStorage.removeItem("rinvox-owner-user-id");
        localStorage.removeItem("dspvoice-user-id");
        localStorage.removeItem("dspvoice-token");
        localStorage.removeItem("signature");
    })
}

export const forceClearCashe = () => {
    // Never inside the native app. This exists to be rid of caches left by older versions of
    // the console in a browser somebody has been using for a year; a webview gets a fresh store
    // with the app and has nothing to be rid of. What it did have was the session the app had
    // just written there for us, which this wiped on the way in — handed over, cleared, and
    // then shown a login for the account that had just been signed into.
    if (isNativeApp()) return;

    if (localStorage.getItem("clear-version") === "100") return;
    localStorage.clear();
    localStorage.setItem("clear-version", "100");

    // A public page -- an offer link, a shared job, an invoice, the sign-up -- needs no session,
    // and is exactly what somebody opens in a browser that has never seen the console. Sending
    // them to the login took them away from the link they came to open.
    const path = window.location.pathname;
    if (path.startsWith("/public/") || path.startsWith("/share/") || path.startsWith("/join")) return;

    window.location.href = "/auth/login";
}




export const setTwilioBuyLine = async (line: TwilioLine) => {
    await setState({ twilioBuyLine: line });
}


export const hasRole = (role?: string) => {

    if (state.user?.username == "root") return true;
    if (state.user?.isSuperAdmin) return true;
    if (!role || role == "") return false;

    if (state.roles && state.roles.indexOf(role) > -1) return true;

    return false;
}

// Access to one restriction resource. Precedence: unrestricted users first, then DENY (which wins
// even over a blanket "{X}All"), then "{X}All", then an explicit grant. Mirrors the server-side
// AccessRule / EffectiveRoleSets.
const hasAccessToResource = (prefix: string, id?: string) => {
    if (!id) return true;

    // EffectiveRoleSets() returns FullAccess for these BEFORE any role folding, so they are never
    // given a "{X}All" role at all. Without the same short-circuit here they fall through to the
    // final `return false` and end up with access to nothing — which silently dropped every live
    // job push for a system admin (addOrUpdateJob gates on hasAccessToSource).
    if (state.user?.username == "root") return true;
    if (state.user?.isSuperAdmin) return true;
    if (state.user?.isSystemAdmin) return true;

    if (state.rolesDenied && state.rolesDenied.includes(prefix + "-" + id)) return false;
    if (state.roles && state.roles.includes(prefix + "All")) return true;
    if (state.roles && state.roles.includes(prefix + "-" + id)) return true;
    return false;
}

export const hasAccessToSource = (id?: string) => hasAccessToResource("Sources", id)

export const hasAccessToJobType = (id?: string) => hasAccessToResource("JobTypes", id)

export const hasAccessToMetro = (id?: string) => hasAccessToResource("Metros", id)

export const hasAccessToTechnician = (id?: string) => hasAccessToResource("Technicians", id)

export const hasAccessToQueue = (qu?: string) => {
    if (state.user?.username == "root") return true;
    if (state.user?.accessAllQueues) return true;
    if (state.user?.isCustomer) return true;

    if (!qu || qu == "") return false;
    if (state.user?.accessQueueIds && state.user?.accessQueueIds.indexOf(qu) > -1) return true;

    return false;
}

export const hasAccessToExt = (ext?: string) => {
    if (state.user?.username == "root") return true;
    if (state.user?.accessAllExtensions) return true;
    if (state.user?.isCustomer) return true;

    if (!ext || ext == "") return false;
    if (state.user?.accessExtensionsIds && state.user?.accessExtensionsIds.indexOf(ext) > -1) return true;

    return false;
}

export const hasRoles = (roles: string[]) => {

    for (var i = 0; i < roles.length; i++) {
        if (hasRole(roles[i])) return true;
    }

    return false;
}

// Office job permissions. The account owner always has them. Technicians are never given these
// roles -- their job actions follow the Tech* account settings -- so they are not narrowed here,
// except closing, which they do through their own TechPendingCloseJob / TechDirectCloseJob flow.
// Mirrors HasJobRole on the server.
export const canListActiveJobs = () => !!state.user?.isTech || hasRole("IsCustomer") || hasRole("ListActiveJobs")

export const canManageJobs = () => !!state.user?.isTech || hasRole("IsCustomer") || hasRole("ManageJobs")

export const canCloseJob = () => hasRole("IsCustomer") || hasRole("CloseJob")

// A job's rates and profit split. A technician is never given office roles, so they see the split
// of their own job unless ViewJobRates is denied to them. Mirrors HasRateRole on the server.
export const canViewJobRates = () => hasRole("IsCustomer") ||
    (state.user?.isTech ? !(state.rolesDenied ?? []).includes("ViewJobRates") : hasRole("ViewJobRates"))

// Closing a job with rates of one's own (custom or fixed). Mirrors HasRateRole on the server.
export const canUseCustomRates = () => hasRole("IsCustomer") || hasRole("CloseJobsCustomRates")

// A job that is still active (not closed or canceled) may only be viewed with ListActiveJobs.
export const isActiveJobDenied = (job?: Job) => !!job && !job.isClosed && !job.isCanceled && !canListActiveJobs()

const notAllowed = (what: string) => toastError("You are not allowed to " + what + ".")

export const validateRole = (role: string) => {
    if (!hasRole(role)) {
        window.location.href = "/";
    }
}

export const playCall = (call: Call) => setState({
    selectedCallToPlay: call,
    floatAudioStatus: {
        loading: true,
        playing: false
    }
})

export const playGlobalPlayer = () => {
    $("#global-float-audio-player").trigger("play");
}

export const pauseGlobalPlayer = () => {
    $("#global-float-audio-player").trigger("pause");
}

export const clearGlobalPlayer = () => setState({ selectedCallToPlay: undefined })

export const setCallToListen = (call: Call | LiveCall) => setState({ selectedCallToListen: call })

export const clearCallToListen = () => setState({ selectedCallToListen: undefined })

export const setChanSpyLine = (line: any) => {
    if (state.ChanSpyLine) {
        window.endSession(state.ChanSpyLine?.LineNumber);
    }
    setState({ ChanSpyLine: line })
}

export const setHangupChannel = (chan?: string) => setState({ hangupChannel: chan })

export const shareCalls = (ids: string[]) => {
    setState({ selectedCallsToShare: ids });
}

export const shareCallsClose = () => {
    setState({ selectedCallsToShare: undefined });
}

const dateFormat = (withoutTime?: boolean) => {
    let res = "DD/MM/YYYY";

    if (state.accountPreferences?.systemPreferences.dateFormat == DateFormats.DDMMM) res = "DD MMM";
    if (state.accountPreferences?.systemPreferences.dateFormat == DateFormats.MMDDYYYY) res = "MM/DD/YYYY";

    if (!withoutTime) {
        if (state.accountPreferences?.systemPreferences.timeFormat == TimeFormats.Format12Hours) res += " - h:mm A"
        else res += " - HH:mm"
    }

    return res;
}


const timeClockFormat = () =>
    state.accountPreferences?.systemPreferences.timeFormat == TimeFormats.Format12Hours ? 'h:mm A'
        : 'HH:mm';


export const toShortDate = (dt?: Date) => {
    var offset = state.user?.timeZoneOffset;
    var now = moment().utc();
    var mdt = moment(dt).utc();
    return mdt.add(offset, "minutes").format("DD MMM - " + timeClockFormat());
}

export const toShortDateWithoutTime = (dt?: Date) => {
    var offset = state.user?.timeZoneOffset;
    var mdt = moment(dt).utc();
    return mdt.add(offset, "minutes").format("DD MMM YYYY");
}

export const toJobDate = (dt?: Date, timezoneOffset?: number) => {
    if (!dt) return undefined;
    return moment(dt).utc().add(timezoneOffset ?? 0, "minutes");
}

export const toPrettyDate = (dt?: Date, timezoneOffset?: number, withoutTime?: boolean) => {
    if (!dt) return "";

    var mdt = moment(dt).utc();

    if (mdt.year() < 1000) return "-";
    var offset = timezoneOffset ?? state.user?.timeZoneOffset ?? 0;

    // if (mdt.isSame(now, 'year')) {
    //     return mdt.add(offset, "minutes").format(dateFormat(withoutTime));
    // }
    return mdt.add(offset, "minutes").format(dateFormat(withoutTime));
}

export const toNormalDate = (dt?: Date, timezoneOffset?: number) => {
    if (!dt) return "";

    var offset = timezoneOffset ?? state.user?.timeZoneOffset ?? 0;
    return moment(dt).utc().add(offset, "minutes").format(dateFormat());
}

export const toDateTime = (dt?: Date, timezoneOffset?: number) => {
    if (!dt) return "";
    var offset = timezoneOffset ?? state.user?.timeZoneOffset ?? 0;
    return moment(dt).utc().add(offset, "minutes").format(dateFormat());
}

export const toAppointmentDate = (from?: Date, to?: Date, timezoneOffset?: number) => {
    if (!from) return "";
    var res = "";
    var offset = timezoneOffset ?? state.user?.timeZoneOffset ?? 0;
    res = moment(from).utc().add(offset, "minutes").format(dateFormat()) + " - " + moment(to).utc().add(offset ?? 0, "minutes").format(timeClockFormat());
    return res;
}

export const toAppointmentHours = (job?: Job): string => {
    var res = "";
    if (job == null) return res;
    if (!job.appointmentTimeFrom) return res;
    if (window.isNullOrEmpty(job.appointmentTimeFrom)) return res;
    var isRange = !window.isNullOrEmpty(job.appointmentTimeTo);

    if (state.accountPreferences?.systemPreferences.timeFormat == TimeFormats.Format12Hours) {
        res = convertTo12HourFormat(job.appointmentTimeFrom, isRange);
        if (isRange) {
            res += "-" + convertTo12HourFormat(job.appointmentTimeTo);
        }
    }
    else {
        res = job.appointmentTimeFrom;
        if (isRange) {
            res += "-" + job.appointmentTimeTo;
        }
    }

    return res;
}



export const deviceToken = (token?: string) => {
    if (token) {
        localStorage.setItem("device-token", token);
        setState({ deviceToken: token });
        return token;
    }
    return localStorage.getItem("device-token");
}

export const signature = (signature?: string) => {
    if (signature) {
        localStorage.setItem("signature", signature);
        return signature;
    }
    return localStorage.getItem("signature");
}


let listeners: any = [];
let state: IState = {
    darkMode: resolveTheme() == "dark",
    page: undefined,
    socketState: HubConnectionState.Connecting
};

const setState = (newState: IState) => {
    state = { ...state, ...newState };
    listeners.forEach((listener: any) => {
        listener(state);
    });
};


export function useGlobal(): [IState, (newState: IState) => void] {
    const newListener = useState()[1];
    useEffect(() => {
        listeners.push(newListener);
    }, []);
    return [state, setState];
}
